// src/api/config.ts

const ENV_CONFIGS = {
  dev: {
    BASE_URL: 'https://df5srfggjxg2u.cloudfront.net/api',
    SECURE_BASE_URL: 'https://df5srfggjxg2u.cloudfront.net/api/secure'
  },
  beta: {
    BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://d3qkbz34jfva30.cloudfront.net/api',
    SECURE_BASE_URL: import.meta.env.VITE_SECURE_API_BASE_URL || 'https://d3qkbz34jfva30.cloudfront.net/api/secure'
  },
  prod: {
    BASE_URL: 'https://d2wsgelz1jdc25.cloudfront.net/api',
    SECURE_BASE_URL: 'https://d2wsgelz1jdc25.cloudfront.net/api/secure'
  }
} as const

const ENV = (import.meta.env.VITE_ENV || 'dev') as keyof typeof ENV_CONFIGS

console.log('[API Config] VITE_ENV:', import.meta.env.VITE_ENV)
console.log('[API Config] Selected ENV:', ENV)
console.log('[API Config] All env vars:', import.meta.env)

export const API_CONFIG = ENV_CONFIGS[ENV]
export const API_BASE = API_CONFIG.BASE_URL
export const SECURE_API_BASE = API_CONFIG.SECURE_BASE_URL

console.log('[API Config] BASE_URL:', API_BASE)
console.log('[API Config] SECURE_BASE_URL:', SECURE_API_BASE)